import { defaultDataIdFromObject } from 'apollo-cache-inmemory';

export const getCacheId = defaultDataIdFromObject;
